// BuildSystem — left-edge rail + slide-out building panel.

import React, { useEffect, useState } from "react";
import { useGame } from "../game/em2c-store";
import BuildCategoryRail from "./BuildCategoryRail";
import EdgeBuildPanel from "./EdgeBuildPanel";
import { X } from "lucide-react";

export default function BuildSystem() {
  const [buildPanelOpen, setBuildPanelOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState("core");

  useEffect(() => {
    const close = () => setBuildPanelOpen(false);
    window.addEventListener("mars:world-click", close);
    const otherMenu = (e) => { if (e.detail?.name !== "build") close(); };
    window.addEventListener("mars:menu-open", otherMenu);
    return () => { window.removeEventListener("mars:world-click", close); window.removeEventListener("mars:menu-open", otherMenu); };
  }, []);

  const placementType = useGame((s) => s.placementType);
  const rotatePlacement = useGame((s) => s.rotatePlacement);
  const cancelPlacement = useGame((s) => s.cancelPlacement);
  const openCodex = useGame((s) => s.openCodex);

  const handleSelectCategory = (catId) => {
    if (buildPanelOpen && activeCategory === catId) {
      setBuildPanelOpen(false);
    } else {
      window.dispatchEvent(new CustomEvent("mars:menu-open", { detail: { name: "build" } }));
      setActiveCategory(catId);
      setBuildPanelOpen(true);
    }
  };

  return (
    <>
      <BuildCategoryRail
        activeCategory={activeCategory}
        panelOpen={buildPanelOpen}
        onSelectCategory={handleSelectCategory}
        onOpenCodex={openCodex}
      />
      <EdgeBuildPanel
        open={buildPanelOpen}
        category={activeCategory}
        onClose={() => setBuildPanelOpen(false)}
        onBuildingSelected={() => setBuildPanelOpen(false)}
      />

      {placementType && (
        <div
          className="absolute bottom-16 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 px-3 py-2 bg-[#0A0C10]/95 border border-cyan-400/40 backdrop-blur-md pointer-events-auto"
          style={{ fontFamily: "Rajdhani, sans-serif" }}
          data-testid="placement-hud"
        >
          <span className="text-[10px] font-mono uppercase tracking-widest text-cyan-400">
            Placing — Left Click to build
          </span>
          <button
            onClick={() => rotatePlacement()}
            className="flex items-center gap-1 px-2 py-1 border border-white/20 bg-white/5 hover:border-cyan-400 hover:text-cyan-400 text-white text-[10px] font-mono uppercase tracking-widest"
          >
            Rotate (R)
          </button>
          <button
            data-testid="btn-cancel-placement"
            onClick={cancelPlacement}
            className="flex items-center gap-1 px-2 py-1 border border-[#ff3366]/60 text-[#ff3366] hover:bg-[#ff3366]/10 text-[10px] font-mono uppercase tracking-widest"
          >
            <X size={12} /> Cancel (Right Click)
          </button>
        </div>
      )}
    </>
  );
}
